/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webParseGetWebparseMetadata } from "../../funcs/webParseGetWebparseMetadata.js";
import { GetWebparseMetadataRequest$zodSchema } from "../../models/getwebparsemetadataop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetWebparseMetadataRequest$zodSchema,
};

export const tool$webParseGetWebparseMetadata: ToolDefinition<typeof args> = {
  name: "web-parse-get-webparse-metadata",
  description: `提取网页元数据

想在应用里做链接预览卡片？这个接口帮你一键获取网页的标题、描述、图标等信息。

## 功能概述
提供一个网页 URL，返回该页面的元数据，包括标题、描述、关键词、Favicon、Open Graph 信息等。非常适合用于生成链接预览卡片或做 SEO 分析。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await webParseGetWebparseMetadata(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
